import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";
import { TooltipProvider } from "./components/ui/Tooltip";
import moment from "moment";
import { Provider } from "react-redux";
import Store from "./redux/Store";
// import reportWebVitals from "./reportWebVitals";

// Configure moment to start the week from Monday globally
moment.updateLocale("en", {
  week: {
    dow: 1, // Monday is the first day of the week
    doy: 7, // Set the first Monday of the year as the start day
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <TooltipProvider>
      <CssBaseline />
      <Provider store={Store}>
        <App />
      </Provider>
    </TooltipProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
